import { TRCFundClasses } from "./tRCFundClasses.model"

export class FundClassGridArgs{
    fundClasses :TRCFundClasses[]=[]
    fromDate = ""
}